<template>
  <b-tag class="tag" :type="tagType" :title="followers.toLocaleString() + ` followers`">{{ tagText }}</b-tag>
</template>

<script>

function formatNumber(num) {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function(item) {
    return num >= item.value;
  });
  return item ? (num / item.value).toFixed(1).replace(rx, "$1") + item.symbol : "0";
}


export default {
  name: "FollowersTag",
  props: {
    followers: Number
  },
  computed: {
    tagType () {
      if (this.followers >= 100000) {
        return 'is-success is-light'
      } else if (this.followers >= 1000) {
        return 'is-warning is-light'
      }
      return 'is-danger is-light'
    },

    tagText () {
      return formatNumber(this.followers)
    }
  }
}
</script>

<style scoped>
  .tag {
    cursor: default;
  }
</style>
